import { usarClarity } from "@/composable/UsarClarity/usarClarity"
import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
import ProfissionalRepositorio from "@/repositorios/profissional/profissional.repositorio"
import {
  ListarProfissionaisSimples,
  ParamsProfissional,
} from "@/repositorios/profissional/profissional.modelo"
import UsuariosRepositorio from "@/repositorios/usuarios/usuarios.repositorio"
import { PerfilDeOrganizacao } from "@/types/gerais"
import SessaoServico from "@/servicos/sessao.service"
import { UsuarioLogado } from "@/repositorios/usuarios/usuarios.modelo"
import { usarPayloadJWT } from "@/composable/UsarPayloadJWT/usarPayloadJWT"

interface MetadadosDaSessao {
  urlRenovacaoTokenKeycloak?: string
  urlLogoutKeycloak?: string
  realmKeycloak?: string
}

const { leitor } = usarLeitorDeDados()
const leitorProfissionais = leitor<
  ListarProfissionaisSimples,
  ParamsProfissional
>(new ProfissionalRepositorio().listarProfissionais)

export function adaptarUsuarioLogadoParaSessao(
  usuario: UsuarioLogado
): UsuarioLogado & { perfilDeOrganizacao: PerfilDeOrganizacao } {
  let perfilDoToken: PerfilDeOrganizacao | undefined
  try {
    perfilDoToken = usarPayloadJWT().obterPerfilDeOrganizacao(
      SessaoServico.token || ""
    )
  } catch {
    perfilDoToken = undefined
  }

  return {
    ...usuario,
    perfilDeOrganizacao:
      usuario.perfilDeOrganizacao || perfilDoToken || "pessoal",
    permissoes:
      usuario.perfilDePermissao?.permissoes ?? usuario.permissoes ?? [],
  }
}

async function carregarProfissionalDoUsuario(): Promise<void> {
  const { id } = SessaoServico.coletarInformacoesDoUsuarioLogado()

  leitorProfissionais.sobrescreverParametros({
    usuario_relacionado: `igual.${id}`,
  })
  await leitorProfissionais.executar()

  if (leitorProfissionais.resultado.status === "sucesso") {
    const profissional = leitorProfissionais.resultado.dados[0]

    SessaoServico.salvarInformacoesDeProfissionalDoUsuario({
      id: profissional.id,
      nome: profissional.nome,
      ativo: profissional.ativo,
    })
    return
  }

  if (leitorProfissionais.resultado.status === "vazio") {
    SessaoServico.salvarInformacoesDeProfissionalDoUsuario()
  }
}

export async function concluirSessaoAutenticada(
  accessToken: string,
  refreshToken: string,
  metadados: MetadadosDaSessao = {}
): Promise<void> {
  SessaoServico.token = accessToken
  SessaoServico.tokenRenovacao = refreshToken
  SessaoServico.tipo = "Bearer"
  SessaoServico.urlRenovacaoTokenKeycloak =
    metadados.urlRenovacaoTokenKeycloak || ""
  SessaoServico.urlLogoutKeycloak = metadados.urlLogoutKeycloak || ""
  SessaoServico.realmKeycloak = metadados.realmKeycloak || ""

  try {
    const usuarioLogado = adaptarUsuarioLogadoParaSessao(
      await new UsuariosRepositorio().obterUsuarioLogado()
    )
    SessaoServico.definirInformacoesDoUsuarioLogado(usuarioLogado)
    await carregarProfissionalDoUsuario()

    usarClarity().enviarPerfilOrganizacaoAoClarity(
      usuarioLogado.perfilDeOrganizacao
    )
  } catch (erro) {
    SessaoServico.limparInformacoesDaSessao()
    throw erro
  }
}
